module.exports = __webpack_public_path__ + "static/media/govtech_black.73500d77.svg";